<template>
    <div :class="{ 'fixed-window': true, 'mobile-fixed-win': !isPc }">
        <div class="rectangle-win">
            <div class="shield-icon">
                <iconpark-icon name="shield-tick"></iconpark-icon>
            </div>
            <div class="title">Viemao</div>
            <div class="second-title">Checking if the site connection is secure</div>
            <div id="html_element" class="g-recaptcha" v-show="!isLoading"></div>
            <div class="loading-area flex-center g-recaptcha" v-show="isLoading">
                <iconpark-icon name="loading" class="loading-icon loading-animation" v-if="isLoading"></iconpark-icon>
            </div>
            <div class="bottom-text">Viemao needs to review the security of your connection before proceeding</div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { CLOUDFLARE_SITEKEY } from "@/constants";
// import i18n from "@/i18n";
import uesUpdateSize from "@/helpers/useUpdateSize";

const emits = defineEmits(["verifyCallback", "errorCallback"]);
// const { t } = i18n.global;

const { isPc } = uesUpdateSize();
const isLoading = ref(false);
const opt_widget_id = ref("");
const createTurnstileNum = ref(0);
const createTurnstileTimer = ref("");

function createTurnstile() {
    clearTimeout(createTurnstileTimer.value);
    try {
        /* global turnstile */
        if (turnstile && turnstile.render) {
            console.log("turnstile success");
            if (opt_widget_id.value) {
                if (!turnstile.isExpired(opt_widget_id.value)) {
                    let token = turnstile.getResponse(opt_widget_id.value);
                    emits("verifyCallback", token);
                    return;
                }
            }
            opt_widget_id.value = turnstile.render("#html_element", {
                sitekey: CLOUDFLARE_SITEKEY,
                callback: function (token) {
                    emits("verifyCallback", token);
                },
                retry: "never",
                language: "en",
                theme: "light",
                "error-callback": function (e) {
                    emits("errorCallback");
                    console.log("visible error", e);
                },
            });
        } else if (createTurnstileNum.value <= 10) {
            createTurnstileNum.value = createTurnstileNum.value + 1;
            createTurnstileTimer.value = setTimeout(() => {
                createTurnstile();
            }, 2000);
        } else {
            emits("errorCallback");
            console.log("turnstile error");
        }
    } catch (e) {
        createTurnstileNum.value = createTurnstileNum.value + 1;
        createTurnstileTimer.value = setTimeout(() => {
            createTurnstile();
        }, 2000);
    }
}

onMounted(() => {
    createTurnstile();
});

onBeforeUnmount(() => {
    if (turnstile && opt_widget_id.value) {
        turnstile.remove(opt_widget_id.value);
    }
    clearTimeout(createTurnstileTimer.value);
});
</script>

<style scoped lang="scss">
.fixed-window {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.48);
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
}
.rectangle-win {
    width: 436px;
    padding: 48px 20px;
    box-sizing: border-box;
    border-radius: 12px;
    background: #ffffff;
}
.shield-icon {
    font-size: 48px;
    color: #3c4659;
}
.title {
    color: #3c4659;
    font-family: Inter-SemiBold;
    font-size: 26px;
    margin: 16px 0px 8px 0px;
}
.second-title {
    font-size: 16px;
    color: #535252;
    font-family: Inter-Medium;
}
.g-recaptcha {
    margin: 32px 0px 48px 0px;
    height: 65px;
}
.loading-area {
    font-size: 32px;
}
.bottom-text {
    font-size: 16px;
    color: #535252;
    font-family: Inter-Medium;
}
.mobile-fixed-win {
    .rectangle-win {
        width: 3.45rem;
        padding: 0.4rem 0.2rem;
    }
    .shield-icon {
        font-size: 0.48rem;
    }
    .title {
        font-size: 0.26rem;
        margin: 0.16rem 0 0.08rem 0;
    }
    .second-title {
        font-size: 0.16rem;
    }
    :deep(.g-recaptcha) {
        margin: 0.32rem 0 0.48rem 0;
        div {
            display: flex;
        }
    }
    .bottom-text {
        font-size: 0.16rem;
    }
    .loading-area {
        font-size: 0.32rem;
    }
}
</style>
